import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import FileUploader from "./FileUploader";
import CardsMerger from "./CardsMerger";
import Overlay from "./Overlay";

const AVMergeComponent = (props) => {
    const [filesList, setFilesList] = useState([]);

    const {
        titleDragNDropSomeFilesHereOrClickToSelectFiles,
        titleDownload,
        titleChoose,
        titleLoadMore,
        titleSelect,
        titleDelete,
        titleReady,
        titleCancel,
        titleMerge,
        titleOverlay,
        tip1,
    } = props.attributes;

    const [fileId, setFileId] = useState("");
    const [fileName, setFileName] = useState("");
    const [showComponent, setShowComponent] = useState("");
    const [activeTab, setActiveTab] = useState("merge");

    const handleDataChange = (
        url,
        duration,
        videoWidthExt,
        videoHeightExt,
        fileId,
        fileName
    ) => {
        setFileId(fileId);
        setFileName(fileName);
        setShowComponent(true);
    };

    const [showUploader, setShowUploader] = useState(true);

    const handleDisplayUploader = (value) => {
        setShowUploader(value);
    };

    const handleFilesChange = (files) => {
        /*  */
        setTimeout(() => {
            setFilesList(files);
            console.log(files.length);
            if (files.length > 0) {
                setShowComponent(true);
            }
        }, 0);
    };

    return (
        <div>
            {showComponent && (
                <>
                    {showUploader && (
                        <div className="flex justify-center my-4">
                            <button
                                className={`px-4 py-2 rounded-lg mr-2 ${
                                    activeTab === "merge"
                                        ? "bg-green-500 text-white"
                                        : "bg-green-200"
                                }`}
                                onClick={() => setActiveTab("merge")}
                            >
                                {titleMerge}
                            </button>
                            <button
                                className={`px-4 py-2 rounded-lg ${
                                    activeTab === "overlay"
                                        ? "bg-green-500 text-white"
                                        : "bg-green-200"
                                }`}
                                onClick={() => setActiveTab("overlay")}
                            >
                                {titleOverlay}
                            </button>
                        </div>
                    )}
                    {/* Условный рендеринг контента в зависимости от активного таба */}
                    {activeTab === "merge" && (
                        <CardsMerger
                            setShowUploader={setShowUploader}
                            filesList={filesList}
                            setFilesList={setFilesList}
                            titleMerge={titleMerge}
                            attributes={props.attributes}
                        />
                    )}

                    {activeTab === "overlay" && (
                        <Overlay
                            setShowUploader={setShowUploader}
                            filesList={filesList}
                            setFilesList={setFilesList}
                            attributes={props.attributes}
                        />
                    )}
                </>
            )}
            <div style={{ marginTop: "20px" }}>
                <FileUploader
                    onFilesChange={handleFilesChange}
                    attributes={props.attributes}
                    setShowComponent={setShowComponent}
                    showUploader={showUploader}
                    onDataChange={handleDataChange}
                />
            </div>
        </div>
    );
};

export default AVMergeComponent;

/* if (document.getElementById("av-merge")) {
    const avMergeElement = document.getElementById("av-merge");
    const root = createRoot(avMergeElement);
    const attributes = {
        titleDragNDropSomeFilesHereOrClickToSelectFiles:
            avMergeElement.getAttribute(
                "titleDragNDropSomeFilesHereOrClickToSelectFiles"
            ),
        titleDownload: avMergeElement.getAttribute("titleDownload"),
        titleChoose: avMergeElement.getAttribute("titleChoose"),
        titleLoadMore: avMergeElement.getAttribute("titleLoadMore"),
        titleSelect: avMergeElement.getAttribute("titleSelect"),
        titleDelete: avMergeElement.getAttribute("titleDelete"),
        titleDeleteAll: avMergeElement.getAttribute("titleDeleteAll"),
        titleReady: avMergeElement.getAttribute("titleReady"),
        titleCurrentFile: avMergeElement.getAttribute("titleCurrentFile"),
        titleCancel: avMergeElement.getAttribute("titleCancel"),
        titleMerge: avMergeElement.getAttribute("titleMerge"),
        titleOverlay: avMergeElement.getAttribute("titleOverlay"),
        titleStart: avMergeElement.getAttribute("titleStart"),
        titleEnd: avMergeElement.getAttribute("titleEnd"),
        titleIndent: avMergeElement.getAttribute("titleIndent"),

        titleShowHideTimeSettings: avMergeElement.getAttribute(
            "titleShowHideTimeSettings"
        ),
        titleChangeStripeColors: avMergeElement.getAttribute(
            "titleChangeStripeColors"
        ),
        titleDuration: avMergeElement.getAttribute("titleDuration"),
        titleLongestFile: avMergeElement.getAttribute("titleLongestFile"),
        titleOverlayResult: avMergeElement.getAttribute("titleOverlayResult"),

        tip1: avMergeElement.getAttribute("tip1"),
        tip2: avMergeElement.getAttribute("tip2"),

        serverUploadUrl: avMergeElement.getAttribute("serverUploadUrl"),
        sessionId: avMergeElement.getAttribute("sessionId"),
    };
    root.render(<AVMergeComponent attributes={attributes} />);
} */
if (document.getElementById("av-merge")) {
    const avMergeElement = document.getElementById("av-merge");
    const root = createRoot(avMergeElement);
    const attributes = { ...avMergeElement.dataset };
    root.render(<AVMergeComponent attributes={attributes} />);
}
